export default __webpack_public_path__ + "static/media/Translation workflow.bc0e244f.docx";